// extracted by mini-css-extract-plugin
export default {"slippage":"change-slippage_slippage__r1KEY","slippageInput":"change-slippage_slippageInput__oPUcg","changeBtn":"change-slippage_changeBtn__E2SKL"};